export default __webpack_public_path__ + "d6fcaaf1731fb3618e0f9c7209c91c43.png";